export var sizes = ['1x', '2x', '3x'];